module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', [_c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/",
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("home")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Home")])], 1)], 1), _vm._v(" "), (_vm.access.viewAllJobs === true && ['Sales', 'Admin', 'Admin and Engineer'].indexOf(_vm.role) !== -1) ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/NewOrder"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("edit")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("New Order")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.access.viewAllJobs === true && ['Support', 'Support and Engineer', 'Sales', 'Admin', 'Admin and Engineer'].indexOf(_vm.role) !== -1) ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/OrderApproval"
    }
  }, [_c('v-list-tile-action', [(_vm.role === 'Sales') ? _c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("close")]) : (['Support', 'Support and Engineer', 'Admin', 'Admin and Engineer'].indexOf(_vm.role) !== -1) ? _c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("mdi-approval")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [(_vm.role === 'Sales') ? _c('v-list-tile-title', [_vm._v("Rejected Orders")]) : (['Support', 'Support and Engineer', 'Admin', 'Admin and Engineer'].indexOf(_vm.role) !== -1) ? _c('v-list-tile-title', [_vm._v("Approve\n            Orders")]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.access.viewAllJobs === true && _vm.role !== 'Supplier') ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/ServiceCalls"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("assignment_late")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Service Calls")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.access.viewAllJobs === true && _vm.role !== 'Supplier') ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/Project"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("mdi-file-tree")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Projects")])], 1), _vm._v(" "), (_vm.$router.currentRoute.name === 'Project') ? _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("refresh")])], 1)], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.access.viewAllJobs === true && _vm.role !== 'Supplier') ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/Jobs"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("mdi-file-document-box")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Jobs")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.access.viewAllJobs === true && _vm.role !== 'Supplier') ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/Finance"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("mdi-credit-card")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Finance")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.access.viewAllJobs === true && _vm.role !== 'Supplier') ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/Customer"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("mdi-account-group")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Customers")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.access.viewAllJobs === true && _vm.role !== 'Supplier') ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/Products"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("mdi-sitemap")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Products")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.access.viewAllJobs === true && _vm.role !== 'Supplier') ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/Admin/Vehicle"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("local_shipping")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Vehicles")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.access.suppliers === true) ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/Supplier"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("assignment_ind")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Suppliers")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.access.viewAllJobs === true && _vm.role !== 'Supplier') ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/Calendar"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("event")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Calendar")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.access.viewAllJobs === true && _vm.role !== 'Supplier') ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/Sites"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("domain")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Sites")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.access.viewAllJobs === true && _vm.role !== 'Supplier') ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/Contacts"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("contacts")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Contacts")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.access.viewAllJobs === true && _vm.role !== 'Supplier') ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/BulkSMS"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("message")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Bulk SMS")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.access.viewAllJobs === true && _vm.role !== 'Supplier') ? _c('v-list-group', {
    attrs: {
      "prepend-icon": "device_hub"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function() {
        return [_c('v-list-tile', [_c('v-list-tile-title', [_vm._v("Devices")])], 1)]
      },
      proxy: true
    }], null, false, 2876426439)
  }, [_vm._v(" "), _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/Devices"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("router")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Hardware Devices")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/Sims"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("sim_card")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("SIMs")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.access.admin === true) ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/Admin"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("verified_user")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Admin")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
    staticClass: "mt-5 mb-2"
  }), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-list-tile', {
    attrs: {
      "router": "",
      "to": "/settings"
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("settings")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Settings")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.userIsAuthenticated) ? _c('v-list-tile', {
    attrs: {
      "router": ""
    },
    on: {
      "click": _vm.onLogout
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Log Out")])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "fixed": "",
      "app": "",
      "color": "secondary",
      "dark": ""
    }
  }, [(_vm.userIsAuthenticated) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../static/img/cubo-icon.png"),
      "width": "50"
    }
  })], 1), _vm._v(" "), _c('v-alert', {
    staticStyle: {
      "position": "fixed",
      "top": "60px",
      "width": "100%",
      "z-index": "100"
    },
    attrs: {
      "value": _vm.newVersion,
      "color": "accent",
      "icon": "history"
    }
  }, [_vm._v("A\n    new version is available "), _c('v-btn', {
    attrs: {
      "color": "success",
      "depressed": ""
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("Update")])], 1), _vm._v(" "), _c('v-content', [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-777aebe5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 756
// module chunks = 1